import { ProductCardNew } from './ProductCardNew';
import { Product } from '../../pages/leasing-store/types';
import { Skeleton } from '../ui/Skeleton';

interface ProductGridProps {
  products: Product[];
  loading?: boolean;
}

export function ProductGrid({ products, loading = false }: ProductGridProps) {
  return (
    <div className="grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
      {loading
        ? Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300">
              <Skeleton width="100%" height={180} className="mb-5 rounded-lg" />
              <Skeleton width="80%" height={20} className="mb-3" />
              <Skeleton width="60%" height={16} className="mb-3" />
              <Skeleton width="40%" height={16} className="mb-5" />
              <Skeleton width="100%" height={36} />
            </div>
          ))
        : products.map((product) => (
            <div key={product.id} className="h-full">
              <ProductCardNew {...product} className="h-full flex flex-col" />
            </div>
          ))}
      {!loading && products.length === 0 && (
        <div className="col-span-full text-center py-12">
          <p className="text-gray-500">Aucun produit ne correspond à vos critères.</p>
        </div>
      )}
    </div>
  );
}